import { NotificationData } from '@constants/user-notifications';

import type { QuotingFlowStore } from '../services/quoting-flow.store';

// -------------------------------
// Quoting flow
// -------------------------------
export const QUOTING_FLOW_STEPS = {
  CLIENT_LOOKUP: { title: 'Client lookup' },
  PROPERTY_REVIEW: { title: 'Property' },
  QUOTE_REVIEW: { title: 'Due today' },
} as const;

export type QuotingFlowStep = keyof typeof QUOTING_FLOW_STEPS;

export type QuotingFlowStepTitle = (typeof QUOTING_FLOW_STEPS)[QuotingFlowStep]['title'];

export const QUOTING_FLOW_STEP_ORDER = [
  'CLIENT_LOOKUP',
  'PROPERTY_REVIEW',
  'QUOTE_REVIEW',
] as const satisfies readonly QuotingFlowStep[];

export type QuotingFlowField =
  | keyof ClientLookupForm['controls']
  | keyof PropertyReviewForm['controls']
  | `customer.${keyof CustomerForm['controls']}`
  | `property.${keyof PropertyForm['controls']}`;

export type NotificationState = {
  invalidFields?: QuotingFlowField[];
  notification: NotificationData;
};

// -------------------------------
// 1) Client lookup
// -------------------------------
export const CLIENT_LOOKUP_TYPES = {
  POLICY_NUMBER: 'policy number',
  SUBMISSION_NUMBER: 'submission number',
} as const;

export type ClientLookupType = (typeof CLIENT_LOOKUP_TYPES)[keyof typeof CLIENT_LOOKUP_TYPES];

export type ClientLookupForm = QuotingFlowStore['clientLookupForm'];

// -------------------------------
// 2) Property review
// -------------------------------
export type PropertyReviewForm = QuotingFlowStore['propertyReviewForm'];
export type CustomerForm = PropertyReviewForm['controls']['customer'];
export type PropertyForm = PropertyReviewForm['controls']['property'];

// -------------------------------
// 3) Quote review
// -------------------------------
export type AxiomQuoteState = {
  emailSent: boolean;
  emailToClient: boolean;
  enrollmentFee: number | undefined;
  id: string | undefined; // UUID used in URL
  monthlyPrice: number | undefined;
  number: string | undefined; // Friendly display value
};
